import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { markAllFormFieldsAsTouched } from '@mt-ng2/common-functions';
import { ICheckInLog } from '../../../model/interfaces/check-in-log';
import { CheckInService } from '../../../check-ins/services/check-ins.service';
import { PublicCheckInDTO } from '../../../model/interfaces/custom/public-check-in-dto';
import { PublicCheckInDynamicControlsPartial } from '../../../model/partials/public-check-in-partial.form-controls';
import { PublicCheckInService } from '../services/public-check-in.service';
import { IExpandableObject } from '../../../model/expandable-object';

@Component({
    selector: 'app-container-input',
    templateUrl: './container-input.component.html',
    standalone: false
})
export class ContainerInputComponent implements OnInit {
    checkInData: PublicCheckInDTO;
    containerInputForm: UntypedFormGroup;
    formControls: IExpandableObject;
    doubleClickIsDisabled = false;
    checkInLog: ICheckInLog;
    constructor(
        private publicCheckInService: PublicCheckInService,
        private router: Router,
        private fb: UntypedFormBuilder,
        private cdr: ChangeDetectorRef,
        private checkInService: CheckInService,
    ) {}

    ngOnInit(): void {
        this.publicCheckInService.checkInData.subscribe((response) => {
            this.checkInData = response;
            this.createForm();
        });
    }

    createForm(): void {
        this.getControls();
    }

    getControls(): void {
        this.formControls = new PublicCheckInDynamicControlsPartial(this.checkInData, [], {
            formGroup: 'containerInputForm',
        }).Form;
        this.cdr.detectChanges();
        this.containerInputForm = this.assignFormGroups();
        this.cdr.detectChanges();
    }

    assignFormGroups(): UntypedFormGroup {
        return this.fb.group({
            containerInputForm: this.fb.group({}),
        });
    }

    addContainer(): void {
        if (this.containerInputForm.valid) {
            const orderNumber = this.containerInputForm.get('containerInputForm.ContainerNumber').value;
            const order = this.publicCheckInService.getEmptyOrder();
            order.OrderNumber = orderNumber;
            this.checkInData.validOrders.push(order);
            this.updateContainerInput();
        } else {
            markAllFormFieldsAsTouched(this.containerInputForm);
        }
    }

    attachOrdersAndSaveCheckIn(): void {
        this.publicCheckInService.checkInData.next(this.checkInData);
        this.publicCheckInService.submitPublicCheckIn(this.checkInData).subscribe(
            (checkInId) => {
                if (checkInId) {
                    this.sendNotifications(checkInId);
                }
            }
        );
    }

    updateContainerInput(): void {
        if (this.checkInData.validOrders.length >= 1) {
            this.containerInputForm.get('containerInputForm.ContainerNumber').reset();
            this.containerInputForm.get('containerInputForm.ContainerNumber').disable();
        } else {
            this.containerInputForm.get('containerInputForm.ContainerNumber').enable();
            this.containerInputForm.get('containerInputForm.ContainerNumber').reset();
        }
    }

    sendNotifications(checkInId: number): void {
        this.checkInService
            .sendNotifications(checkInId)            .subscribe(
                (answer) => {
                    if (answer) {
                        this.createCheckInLogAndNavigateToSuccessPage(
                            checkInId,
                            '[PUBLIC DELIVERY CHECK-IN] driver checked in and navigated to success page. Notifications sent successfully.',
                        );
                    }
                },
                () => {
                    this.createCheckInLogAndNavigateToSuccessPage(
                        checkInId,
                        '[PUBLIC DELIVERY CHECK-IN] driver checked in and navigated to success page, but notifications failed to send.',
                    );
                },
            );
    }

    createCheckInLogAndNavigateToSuccessPage(checkInId: number, message: string): void {
        this.checkInService.createCheckInLog(this.createCheckInLog(message, checkInId)).subscribe(() => {
            void this.router.navigate(['public/delivery/success']);
        });
    }

    createCheckInLog(log: string, checkInId: number): ICheckInLog {
        this.checkInLog = {
            CheckInId: checkInId,
            DateCreatedUtc: new Date(),
            Id: 0,
            LogMessage: log,
        };
        return this.checkInLog;
    }

    removeContainer(orderId: number): void {
        this.checkInData.validOrders = this.checkInData.validOrders.filter((x) => x.OrderId !== orderId);
        this.updateContainerInput();
    }
}
